"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const capitalize_1 = require("./capitalize");
const tokenize_1 = require("./tokenize");
/*
 * Sentence case the given string.
 *
 * @Param {string} text = The text to sentence case.
 *
 * @Example
 *
 *   sentenceCase('CurvedBanana')
 *   //=> "Curved banana"
 */
function sentenceCase(text) {
    return tokenize_1.tokenize(text)
        .map((word, i) => {
        if (i === 0) {
            return capitalize_1.capitalize(word);
        }
        return word.toLowerCase();
    })
        .join(" ");
}
exports.sentenceCase = sentenceCase;
//# sourceMappingURL=sentence-case.js.map